import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import styled from 'styled-components';
import Icon from '../Icon/Icon';
export const AccordionStyled = styled(Accordion).attrs({
    disableGutters: true,
})(({ theme, }) => {
    var _a;
    return ({
        borderBottom: `1px solid ${(_a = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _a === void 0 ? void 0 : _a[300]}`,
        ':last-child': {
            borderBottom: 'none',
        },
        '&:before': {
            display: 'none',
        },
    });
});
export const AccordionSummaryStyled = styled(AccordionSummary)(({ theme, }) => ({
// Add styles here
}));
export const AccordionDetailsStyled = styled(AccordionDetails)(({ theme, }) => ({
// Add styles here
}));
export const IconStyled = styled(Icon).attrs({
    name: 'chevron-down',
})(({ theme, }) => {
    var _a, _b;
    return ({
        color: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.primary,
    });
});
//# sourceMappingURL=Accordion.styles.js.map